var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dcw-timeline-gallery",class:[
    ( _obj = {}, _obj[("dcw-timeline-gallery--" + (_vm.images.length))] = true, _obj[("dcw-timeline-gallery--" + _vm.variant)] = true, _obj[("dcw-timeline-gallery--" + _vm.layout)] = !!_vm.layout, _obj )
  ]},_vm._l((_vm.images),function(image,index){return _c('DcwImage',_vm._b({key:index,staticClass:"dcw-timeline-gallery__image"},'DcwImage',image,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }